import {
    URLAPI,
    VACANCIES_PATH,
    VACANCIES_CREATE_PATH,
    VACANCIES_REPORT_PATH,
    VACANCIES_DETAILS_PATH,
    VACANCIES_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_vacancies: {
        data: [],

        status: 0,
        message: {},
    },
    _create_vacancies: {
        data: {},
        status: 0,
        message: {},
    },
    _update_vacancies: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_VACANCIES = "GET_ALL_VACANCIES";
export const CREATE_VACANCIES = "CREATE_VACANCIES";
export const UPDATE_VACANCIES = "UPDATE_VACANCIES";
export const GET_REPORT = "GET_REPORT";

export const vacancies_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_VACANCIES:
            return {
                ...state,
                _get_all_vacancies: action.payload,
            };
        case CREATE_VACANCIES:
            return {
                ...state,
                _create_vacancies: action.payload,
            };
        case UPDATE_VACANCIES:
            return {
                ...state,
                _update_vacancies: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllVacancies = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${VACANCIES_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_VACANCIES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_VACANCIES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_VACANCIES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemVacancies = async (token, id) => {
    return await axios.get(`${URLAPI}${VACANCIES_DETAILS_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create vacancies
export const createVacancies = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${VACANCIES_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_VACANCIES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_VACANCIES,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_VACANCIES,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateVacancies = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${VACANCIES_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_VACANCIES,
            payload: {
                data: response.data,
                status: response.status,
                message: response.data.mensaje,
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_VACANCIES,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_VACANCIES,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error en el servidor",
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + VACANCIES_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_vacancies = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
